import React from 'react';
import { t } from 'ttag';
import { generatePath } from 'react-router-dom';

import { ProductCard, Product } from '@components/ProductCard';
import Grid from '@components/Grid';
import { Button } from '@ui/Button';
import { collections } from '@urls';
import { sendTopSellerProductsBlockClick } from '@utils/analytics';

// styles
import s from './ConversionTopSellerProducts.sss';

// types
type ConversionTopSellerProductsProps = {
  products: Product[];
};

export const ConversionTopSellerProducts: React.FC<ConversionTopSellerProductsProps> = ({
  products,
}) => (
  <div className={s.root}>
    <div className={s.productsWrapper}>
      <Grid container={true} spacing={10}>
        {
          products.map((product, k) => (
            <Grid
              key={product.id}
              desktop="2_4"
              tablet={4}
              def={6}
            >
              <ProductCard
                {...product}
                onProductClick={() => {
                  sendTopSellerProductsBlockClick(k + 1, product.id);
                }}
              />
            </Grid>
          ))
        }
      </Grid>
    </div>
    <Button
      theme="secondary"
      className={s.button}
      href={generatePath(collections, { slug: 'tovary-ot-top-prodavcov' })}
    >
      {t`Дивитись усе`}
    </Button>
  </div>
);
